import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-text-md text-white" }

import { setToken, setUser } from "@/api/services/auth"
import { useRouter } from "vue-router"
import { useSettingsStore } from "@/api/store/settings"
import { reactive } from "vue";
import { useUserStore } from "@/api/store/user";
import AddressManager from "./ClientComponents/AddressManager.vue";
import FormField from "@/components/Forms/FormField.vue";
import { clientService } from "@/api/services/client";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssociatedAccounts',
  setup(__props) {

const settingsStore = useSettingsStore();
const userStore = useUserStore();

const router = useRouter();

const logout = () => {
    userStore.logout();
    router.push({ name: "login" });
}

const state = reactive({
    client: null as any,
});

const fetchClient = async () => {
    // Fetch client data
    clientService.me().then((response: any) => {
        state.client = response;
    })
};

fetchClient();

const switchAccount = async (account: any) => {
    try {
        const response = await clientService.switchAccount(account.id);
        
        if (response.success) {
            // Set the new token and user data
            setToken(response.token.access_token);
            setUser(response.user);
            
            // Update the user store with the new user data and authentication state
            userStore.user = response.user;
            userStore.token = response.token.access_token;
            userStore.logged_in = true;
            
            // Save to localStorage
            localStorage.setItem("lsUser", JSON.stringify({
                user: response.user,
                token: response.token.access_token,
                logged_in: true
            }));
            
            // Navigate to client details
            window.location.href = "/";
        } else {
            console.error('Failed to switch account:', response.error);
            // You might want to show an error message to the user here
        }
    } catch (error) {
        console.error('Error switching account:', error);
        // You might want to show an error message to the user here
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { style: {"background-color":"#F5F5F5"} }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "mt-5" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                label: "Log out",
                onClick: logout,
                class: "b-round-20 text-white",
                color: _unref(settingsStore).settings.primaryColor
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Log Out", -1)
                ]))]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "mt-5 mb-5" }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("p", { class: "p-text-lg" }, "Associated Accounts", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      (state.client)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("p", { class: "p-text-md" }, "Select an account to switch to", -1)
                ]))]),
                _: 1
              }),
              (state.client.associated_clients)
                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "mt-10"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.client.associated_clients, (account, index) => {
                                return (_openBlock(), _createBlock(_component_v_col, {
                                  key: index,
                                  cols: "12",
                                  class: "d-flex justify-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_sheet, {
                                      color: _unref(settingsStore).settings.buttonColor,
                                      class: "pa-3 mx-4 b-round-20 text-center",
                                      elevation: "3",
                                      height: "110",
                                      width: "120",
                                      onClick: ($event: any) => (switchAccount(account))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          class: "my-2 text-white",
                                          icon: "fa fa-user",
                                          size: "40"
                                        }),
                                        _createElementVNode("p", _hoisted_1, _toDisplayString(account.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})